import { HealthAnalysisJourneyStateModel } from './model/health-analysis-journey-state.model';
import { HealthAnalysisJourneyStepEnum } from './enum/health-analysis-journey-step.enum';
import { FORMS } from '../../../shared/const/forms.const';

export const HEALTH_ANALYSIS_JOURNEY_STEPS = (): { [key: string]: HealthAnalysisJourneyStateModel } => {
    return {
        IN_STOCK: {
            alias: 'Estoque',
            description: 'Exame criado',
            icon: 'uii-box',
            method: 'updateHealthAnalysisAsSentInBatch',
            name: HealthAnalysisJourneyStepEnum.IN_STOCK,
        },
        SENT: {
            alias: 'Enviado',
            description: 'Já enviado ao cliente/prescritor',
            form: FORMS(HealthAnalysisJourneyStepEnum.SENT),
            icon: 'uii-delivery-truck',
            method: 'updateHealthAnalysisAsCollectedInBatch',
            name: HealthAnalysisJourneyStepEnum.SENT
        },
        COLLECTED: {
            alias: 'Coletado',
            description: 'Cliente já realizou a coleta',
            form: FORMS(HealthAnalysisJourneyStepEnum.COLLECTED),
            icon: 'uii-pipette',
            method: 'updateHealthAnalysisAsReceivedInBatch',
            name: HealthAnalysisJourneyStepEnum.COLLECTED
        },
        RECEIVED: {
            alias: 'Recebida',
            description: 'Recebemos no laboratório',
            form: FORMS(HealthAnalysisJourneyStepEnum.RECEIVED),
            icon: 'uii-location-dot',
            method: 'updateHealthAnalysisAsLabStartedInBatch',
            name: HealthAnalysisJourneyStepEnum.RECEIVED,
        },
        PROCESSING_IN_LABORATORY: {
            alias: 'Processando',
            description: 'As amostras estão em processamento',
            form: FORMS(HealthAnalysisJourneyStepEnum.PROCESSING_IN_LABORATORY),
            icon: 'uii-microscope',
            method: 'updateHealthAnalysisAsProcessed',
            name: HealthAnalysisJourneyStepEnum.PROCESSING_IN_LABORATORY,
        },
        BIOINFORMATIC: {
            alias: 'Bioinformática',
            description: 'Workflow do exame será executado',
            icon: 'uii-computer',
            method: 'updateHealthAnalysisAndStartWorkflow',
            name: HealthAnalysisJourneyStepEnum.BIOINFORMATIC,
        },
        COMPLETED: {
            alias: 'Concluído',
            description: 'Análise concluída',
            icon: 'uii-circle-check',
            name: HealthAnalysisJourneyStepEnum.COMPLETED,
            method: '',
        },
        RECOLLECTED: {
            alias: 'Recoletado',
            description: 'Necessário recoleta',
            icon: 'uii-recycle',
            name: HealthAnalysisJourneyStepEnum.RECOLLECTED,
            method: '',
            invisible: true
        }
    }
};
